import styles from './MemberTable.module.scss'

import Button from '@/components/Button'
import { Member } from '@/types'
import { captureEvent } from '@/utils/captureEvent'
import { EventName, PLATFORM_ADMIN_PORTAL } from '@/utils/eventDefinitions'

export const DOMAIN_INFO_USER_LIMIT = 500

interface UserRowProps {
  email: string
  onAdd: () => void
  isLoading: boolean
}

const UserRow = (props: UserRowProps) => {
  const { email, onAdd, isLoading } = props

  return (
    <div className={styles.userRow}>
      <div className={styles.profile}>
        <div className={styles.userInfo}>
          <div className={styles.name}>{email}</div>
        </div>
      </div>

      <div className={styles.action}>
        <Button title="Add" onClick={onAdd} type="light" width={80} isDisabled={isLoading} />
      </div>
    </div>
  )
}

interface OtherDomainUsersTableProps {
  sortedOrphanedUsers: Member[] | null
  onInvite: (email: string) => void
  isLoading: boolean
  isScimEnabled: boolean
  isDomainUsersCapped: boolean
}

export default function OtherDomainUsersTable(props: OtherDomainUsersTableProps) {
  const { sortedOrphanedUsers, onInvite, isLoading, isScimEnabled, isDomainUsersCapped } = props

  if (isScimEnabled) {
    return (
      <div className={`${styles.usersTable} ${styles.otherDomainTable}`}>
        <div className={styles.userRow}>
          <span className={styles.trialStatusText}>
            User management is controlled by your identity provider via SCIM. Please add users through your identity
            provider.
          </span>
        </div>
      </div>
    )
  }

  return (
    <div className={`${styles.usersTable} ${styles.otherDomainTable}`}>
      {sortedOrphanedUsers?.map((user) => (
        <UserRow
          key={user.email}
          email={user.email}
          onAdd={() => {
            captureEvent(EventName.TeamDomainUserAddClicked, {
              email_domain: user.email.split('@')[1] ?? '',
              platform: PLATFORM_ADMIN_PORTAL,
            })
            onInvite(user.email)
          }}
          isLoading={isLoading}
        />
      ))}
      {isDomainUsersCapped && (
        <div className={styles.capNote}>
          <span className={styles.trialStatusText}>Showing a maximum of {DOMAIN_INFO_USER_LIMIT} users</span>
        </div>
      )}
    </div>
  )
}
